import { motion, AnimatePresence } from "framer-motion";
import { X, ShieldCheck } from "@phosphor-icons/react";
import { useLanguage } from "../i18n";

export const PrivacyPolicy = ({ open, onClose }) => {
  const { t } = useLanguage();
  return (
    <AnimatePresence>
      {open && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}
          className="fixed inset-0 z-[80] bg-ink/95 backdrop-blur-xl overflow-y-auto"
          data-testid="privacy-page"
          role="dialog"
          aria-label={t.privacy.title}
        >
          <div className="max-w-3xl mx-auto px-6 py-16 md:py-24">
            <div className="flex items-start justify-between gap-6">
              <div>
                <div className="flex items-center gap-3 text-brand-cyan">
                  <ShieldCheck size={26} weight="duotone" />
                  <span className="font-mono text-[11px] uppercase tracking-[0.3em]">GDPR</span>
                </div>
                <h1 className="mt-4 font-display font-semibold tracking-tight text-3xl md:text-4xl" data-testid="privacy-title">
                  {t.privacy.title}
                </h1>
                <p className="mt-2 font-mono text-xs text-white/35">{t.privacy.updated}</p>
              </div>
              <button
                onClick={onClose}
                data-testid="privacy-close-button"
                aria-label={t.privacy.close}
                className="shrink-0 w-11 h-11 rounded-full border border-white/15 flex items-center justify-center text-white/60 hover:border-brand-cyan/50 hover:text-brand-cyan transition-colors duration-300"
              >
                <X size={20} weight="bold" />
              </button>
            </div>

            <div className="mt-12 space-y-10" data-testid="privacy-content">
              {t.privacy.sections.map((s, i) => (
                <div key={i} data-testid={`privacy-section-${i}`}>
                  <h2 className="font-display font-medium text-lg md:text-xl tracking-tight text-brand-cyan">{s.h}</h2>
                  <p className="mt-3 font-mono text-xs md:text-sm text-white/55 leading-relaxed">{s.p}</p>
                </div>
              ))}
            </div>

            <button
              onClick={onClose}
              data-testid="privacy-close-bottom-button"
              className="mt-14 rounded-full bg-brand-cyan text-ink px-8 py-3.5 font-mono text-xs uppercase tracking-widest font-bold hover:bg-brand-green transition-colors duration-300"
            >
              {t.privacy.close}
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
